import { createStore } from './main';

export type { State } from './types';

export const store = createStore();
